import script from "./AccordionFAQ.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionFAQ.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionFAQ.vue?vue&type=style&index=0&id=565c0cce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-565c0cce"]])

export default __exports__